import { useState } from "react";
import "../styles/Register.css";
import Select from "react-select";
import UseSignup from "../../hooks/useSignup";
import Swal from "sweetalert2";
import { Navigate } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { degreeOptions, programOptions, branchOptions } from "./options";

function Register() {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      background: "#bdd4e7",
      borderRadius: state.isFocused ? "5px 5px 5px 5px" : 5,
      borderColor: state.isFocused ? "white" : "black",
      boxShadow: state.isFocused ? null : null,
      width: 325,
      marginBottom: 6,
      marginTop: 0,
      padding: 0,
      paddingLeft: 15,
      "&:hover": {
        borderColor: state.isFocused ? "white" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
      fontSize: 16,
      marginTop: 5,
    }),
    input: (base) => ({
      ...base,
      color: "black",
      height: 40,
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "black", 
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
  };

  const [name, setName] = useState("");
  const [rollNumber, setRollNumber] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [contactValid, setContactValid] = useState(true);
  const [program, setProgram] = useState("");
  const [degree, setDegree] = useState("");
  const [department, setDepartment] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordMatch, setPasswordMatch] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleConfirmPasswordChange = (event) => {
    const confirmPasswordValue = event.target.value;
    setConfirmPassword(confirmPasswordValue);
    if (confirmPasswordValue === "") setPasswordMatch(true);
    else setPasswordMatch(password === confirmPasswordValue);
  };

  const handleNameChange = (event) => setName(event.target.value);
  const handleRollNumberChange = (event) => setRollNumber(event.target.value);
  const handleContactNumberChange = (event) => {
    // allow only digits and limit to 10 characters
    const digitsOnly = event.target.value.replace(/\D/g, "");
    const truncated = digitsOnly.slice(0, 10);
    setContactNumber(truncated);
    setContactValid(/^[0-9]{10}$/.test(truncated) || truncated.length === 0);
  };
  const handleProgramChange = (event) => setProgram(event.value);
  const handleDegreeChange = (event) => setDegree(event.value);
  const handleDepartmentChange = (event) => setDepartment(event.value);
  const handlePasswordChange = (event) => {
    const passwordValue = event.target.value;
    setPassword(passwordValue);
    if (passwordValue === "") setPasswordMatch(true);
    else setPasswordMatch(passwordValue === confirmPassword);
  };

  const allFieldsFilled = () => {
    return (
      name !== "" &&
      rollNumber !== "" &&
      contactNumber !== "" &&
      contactValid &&
      program !== "" &&
      degree !== "" &&
      department !== "" &&
      password !== "" &&
      confirmPassword !== "" &&
      passwordMatch
    );
  };

  const { signup, loading, error, success } = UseSignup();

  const handleRegistration = async () => {
    const userData = {
      fullname: name,
      ldap: `${rollNumber}@iitb.ac.in`.toLowerCase(),
      dept: department,
      degree: degree,
      program: program,
      password: password,
      contact: contactNumber,
    };

    signup(userData);
  };

  const inputStyle = ["input"];
  const buttonStyle = ["button"];
  const disabledButtonStyle = ["button", "button-disabled"];

  return localStorage.getItem("accessToken") !== null ? (
    <Navigate to="/mentorCards" />
  ) : (
    <div className="form-container">
      <h1 className="heading">REGISTER</h1>
      <input
        type="text"
        placeholder="Name"
        value={name}
        onChange={handleNameChange}
        className="input"
        required
      />
      <div className="email-input">
        <input
          type="text"
          placeholder="Roll Number"
          value={rollNumber}
          onChange={handleRollNumberChange}
          className={inputStyle.join(" ")}
        />
        <span className="email-domain">@iitb.ac.in</span>
      </div>
      <div className="email-input">
        <span
          style={{ width: "50px", marginRight: "8px", marginLeft: "-1px" }}
          className="email-domain"
        >
          +91
        </span>

        <input
          style={{ width: "100px !important" }}
          type="text"
          placeholder="Contact Number"
          value={contactNumber}
          onChange={handleContactNumberChange}
          className={inputStyle.join(" ")}
        />
      </div>
      <Select
        onChange={handleProgramChange}
        placeholder={<div style={{ color: "rgba(0,0,0,0.7)" }}>Program</div>}
        styles={customStyles}
        options={programOptions}
      />
      <Select
        onChange={handleDegreeChange}
        placeholder={<div style={{ color: "rgba(0,0,0,0.7)" }}>Degree</div>}
        styles={customStyles}
        options={degreeOptions}
      />
      <Select
        onChange={handleDepartmentChange}
        placeholder={<div style={{ color: "rgba(0,0,0,0.7)" }}>Department</div>}
        styles={customStyles}
        options={branchOptions}
      />      
      <div style={{ position: 'relative'}}>
        <input
          type={showPassword ? 'text' : 'password'}
          placeholder="Password"
          value={password}
          onChange={handlePasswordChange}
          className={inputStyle.join(" ")}
          style={{ paddingRight: 40 }}
        />
        <i
          className={showPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: 'black',
            fontSize: 18,
            opacity: 0.9,
          }}
        />
      </div>

      <div style={{ position: 'relative', marginBottom: 8 }}>
        <input
          type={showConfirmPassword ? 'text' : 'password'}
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          className={inputStyle.join(" ")}
          style={{ paddingRight: 40 }}
        />
        <i
          className={showConfirmPassword ? 'fas fa-eye' : 'fas fa-eye-slash'}
          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
          style={{
            position: 'absolute',
            right: 10,
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            color: 'black',
            fontSize: 18,
            opacity: 0.9,
          }}
        />
      </div>
      <div style={{ color: "white" }}>
        {!passwordMatch && "Passwords do not match"}
      </div>
      <div style={{ color: "white" }}>{error}</div>
      <button
        onClick={handleRegistration}
        className={
          allFieldsFilled()
            ? buttonStyle.join(" ")
            : disabledButtonStyle.join(" ")
        }
        disabled={!allFieldsFilled()}
      >
        REGISTER
      </button>
      <div style={{ color: "rgba(255,255,255,0.8)", fontSize: "large" }}>
        Already Registered? <a href="/login">Login</a>
      </div>
    </div>
  );
}

export default Register;
